import { SetStateAction, Updater } from "./types";

const isUpdater = <T>(updater: SetStateAction<T>): updater is Updater<T> =>
  typeof updater === "function";

export const resolveSetStateAction = <T>(
  action: SetStateAction<T>,
  prev: T,
): T => (isUpdater(action) ? action(prev) : action);
